$(document).ready(function () {
  "use strict";
  
  // **..product-accordion js start..**
  $(".product-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".product-accordion-item-content")
      .slideUp();
  });
  // **..product-accordion js end..**
});

// btn js ---
// primary btn---
$(function () {
  $(".primary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});

// secondary btn--
$(function () {
  $(".secondary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});
// btn js ---

// testimonial-slider js start--
var swiper = new Swiper(".testimonial-slider", {
  slidesPerView: 3,
  spaceBetween: 24,
  grabCursor: true,
  loop: true,
  speed: 1000, // Speed of transition
  navigation: {
    nextEl: ".testimonial-slider-btn-next",
    prevEl: ".testimonial-slider-btn-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 8,
      slidesPerView: 1.17,
    },
    // when window width is >= 430px
    576: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    // when window width is >= 767px
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    // when window width is >= 767px
    993: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1180: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
});

// image slider--
var swiper = new Swiper(".image_slider", {
  slidesPerView: 3,
  spaceBetween: 24,
  grabCursor: true,
  loop: true,
  speed: 1000, // Speed of transition
  navigation: {
    nextEl: ".swiper-button-prev",
    prevEl: ".swiper-button-next",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 8,
      slidesPerView: 1.17,
    },
    // when window width is >= 430px
    576: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    // when window width is >= 767px
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    // when window width is >= 767px
    993: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1180: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
});
// image slider end--

// product-slider js start---
var swiper = new Swiper(".product-details-slider-thumb", {
  slidesPerView: 2,
  grid: {
    rows: 20, // Number of rows in your grid
  },
  spaceBetween: 0,
});
var swiper2 = new Swiper(".product-details-slider", {
  loop: false,
  autoHeight: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".product-details-slider-next",
    prevEl: ".product-details-slider-prev",
  },
  pagination: {
    el: ".product-slider-pagination",
    clickable: true,
  },
  thumbs: {
    swiper: swiper,
  },
});
// product-slider js end---


$(document).ready(function(){
  $('.quantity-decrease').on('click', function(){
    let qty = parseInt($(this).prev().val());
    qty += 1;
    $('.quantity-count').val(qty);
  })

  $('.quantity-increase').on('click', function(){
    let qty = parseInt($(this).next().val());
    if(qty > 1) {
       qty -= 1;
      $('.quantity-count').val(qty);
    }
  })

  $(".addToCart").on("click", function (e) {
    e.preventDefault();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $("#onetime_form").serialize(),
      dataType: "json",
      success: function (data) {
        // console.log(data);
        // $("body").addClass("cartShown");
        // cart_drawer_update();
         console.log('added');
         window.location.href = '/checkout';
      },
      error: function (err) {
        console.log("Error", err);
      },
    });
  });
  $(".subsAddToCart").on("click", function (e) {
   
    e.preventDefault();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $("#susb_form").serialize(),
      dataType: "json",
      success: function (data) {
        // console.log(data);
        // $("body").addClass("cartShown");
        // cart_drawer_update();
        console.log('added');
        window.location.href = '/checkout';
      },
      error: function (err) {
        console.log("Error", err);
      },
    });
  });

  
})

function copyCode(btn, code) {
  navigator.clipboard.writeText(code).then(() => {
    btn.firstChild.nodeValue = 'Copied ';

    setTimeout(() => {
      btn.firstChild.nodeValue = 'Copy code ';
    }, 8000);
  });
}